const features = [
  {
    icon: 'ri-robot-line',
    title: 'AI Chat Assistant',
    description: 'Respond to every enquiry instantly, qualify leads automatically, and engage customers around the clock — without lifting a finger.',
    points: ['Instant responses 24/7', 'Smart lead qualification', 'Multi-language support'],
  },
  {
    icon: 'ri-whatsapp-line',
    title: 'WhatsApp Automation',
    description: 'Send automated replies, booking confirmations, and follow-ups over WhatsApp — the channel your customers already use.',
    points: ['Auto replies & follow-ups', 'Booking confirmations', 'Reduce manual messages'],
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Smart CRM',
    description: 'Track every lead through a visual pipeline. See where each customer is in the journey and never let a deal go cold.',
    points: ['Visual pipeline board', 'Track all leads & history', 'Manage bookings & tasks'],
  },
  {
    icon: 'ri-arrow-up-circle-line',
    title: 'Booking Conversion System',
    description: 'Turn enquiries into confirmed bookings with automated reminders, quotes, and follow-up sequences that work.',
    points: ['Automated follow-up sequences', 'Quote & invoice generation', 'Higher close rate'],
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 md:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <p className="text-sm font-medium uppercase tracking-wider mb-3 bg-gradient-to-r from-teal-500 to-indigo-500 bg-clip-text text-transparent">Features</p>
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 leading-tight tracking-tight">
            Everything You Need to Run Your<br />
            <span className="bg-gradient-to-r from-teal-400 to-indigo-400 bg-clip-text text-transparent">Travel agency on Autopilot</span>
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-white border border-gray-100 rounded-xl p-6 hover:border-teal-100 hover:bg-teal-50/20 transition-all duration-200 cursor-default"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg mb-5 group-hover:bg-gradient-to-br group-hover:from-teal-500 group-hover:to-indigo-500 transition-all duration-200">
                <i className={`${feature.icon} text-gray-600 text-lg group-hover:text-white transition-colors duration-200`} />
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed mb-4">{feature.description}</p>
              <ul className="flex flex-col gap-2">
                {feature.points.map((point) => (
                  <li key={point} className="flex items-center gap-2 text-xs text-gray-500">
                    <i className="ri-check-line text-teal-500 text-sm" />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
